import React, {Component} from 'react'

const remote = '//d269144czlrk6r.cloudfront.net/kellybarrow/'
const ext = '.jpg'

class Gallery extends Component {


	start()
	{
		let slides = document.querySelectorAll('.Slide');
		let index = 0;
		let max = slides.length - 1
		let current = slides[0]
		current.classList.add('is-active')

		setInterval(() => {
			index++
			if(index > max) index = 0

			let nextSlide = slides[index]
			nextSlide.classList.add('is-active')
			current.classList.remove('is-active')

			current = nextSlide
		},700)
	}

	componentDidMount = () => {
		let {slides} = this.props
		let numSlides = slides.length
		let loaded = 0
		let _this = this

		slides.map(slide => {
			let i = new Image();
			i.onload = () => {
				loaded++
				if(loaded >= numSlides) {
					_this.start()
				}
			}
			i.src = remote + slide + ext
		})

	}


  render () {

  		let {slides} = this.props

  		return (
  			<div className="Gallery">
  				{slides.map(slide => {
  					return (<div className="Slide" style={{backgroundImage:'url('+remote + slide + ext+')'}}/>)
  				})}
  			</div>
  			)
  	}

 }

 export default Gallery


// WEBPACK FOOTER //
// ./src/Gallery.js